import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectorRef, Component, ContentChild, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { debounceTime, Subject } from 'rxjs';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { KeyboardService } from 'src/app/shared/components/keyboard/keyboard.service';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { S3_URL_BASE } from 'src/environments/environment';
import { PeriodicElement } from '../../../user-group-permissions/user-group-permissions.component';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { IEvents } from 'src/app/domain/registration/models/IEvents';
import { EventsService } from '../../crud-service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';

@Component({
  selector: 'app-events-table',
  templateUrl: './events-table.component.html',
  styleUrls: ['./events-table.component.sass'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class EventsTableComponent implements OnInit {
  @ContentChild(TemplateRef)
  templateRef: TemplateRef<any>;

  expandedElement: PeriodicElement | null;

  constructor(
    public keyboardService: KeyboardService,
    private dialog: MatDialog,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private eventsService: EventsService,
    private toastService: ToastService,
  ) { }

  @Input() hasFilter: boolean = true;
  @Input() lockProperty: string = '';
  @Input() activeProperty: string = '';
  @Input() lockPeopleProperty: string = '';
  @Input() showLock: boolean = false;
  @Input() showActive: boolean = false;
  @Input() showPeopleLock: boolean = false;
  @Input() showKey: boolean = false;
  @Input() showQrCode: boolean = false;
  @Input() hasAdd: boolean = true;
  @Input() type: TypeIndexEnum = TypeIndexEnum.CRUD;
  @Input() length: number = 0;
  @Output() changePage: EventEmitter<any> = new EventEmitter<any>();
  @Output() filter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelectionChange: EventEmitter<any> = new EventEmitter<any>();

  keyboardChange: EventEmitter<any> = new EventEmitter<any>();
  filterValue: string = '';

  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  selection = new SelectionModel<any>(true, []);

  ngOnInit(): void {
    this.keyboardChange.subscribe((event) => {
      this.applyFilter(event);
    });

    this.filterSubject.pipe(debounceTime(500)).subscribe((value) => {
      this.filter.emit(value?.toUpperCase());
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataSource']) {
      this.cdr.detectChanges();
    }
    if (this.dataSource) {
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = (item, property) => {
        // Função auxiliar para converter datas em vários formatos
        const parseDateTime = (value: string): number => {
          if (!value) return Number.POSITIVE_INFINITY;
          const cleanedValue = value.replace(/\s+/g, ' ').trim();
          let match = cleanedValue.match(/^(\d{2})\/(\d{2})\/(\d{4})[ ,]? ?(\d{2})?:?(\d{2})?$/);
          if (match) {
            const [, day, month, year, hour = '00', minute = '00'] = match;
            return new Date(`${year}-${month}-${day}T${hour}:${minute}:00`).getTime();
          }
          // Não é data: retorna um valor fixo para ordenar sempre  depois das datas
          return Number.POSITIVE_INFINITY;
        };

        if ((property === 'createdAt') && item[property]) {
          console.log('RETORNO:', parseDateTime(item[property]))
          return parseDateTime(item[property]);
        }
        console.log('RETORNO:', item[property], '::::', typeof item[property])
        return item[property];
      };
    }
  }


  public pageEvent(event: PageEvent): PageEvent {
    this.changePage.emit({ page: event.pageIndex, limit: event.pageSize });
    // this.lowValue = event.pageIndex * event.pageSize;
    // this.highValue = this.lowValue + event.pageSize;
    return event;
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions = setPageSizeOptionsInput
        .split(',')
        .map((str) => +str);
    }
  }

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort: MatSort = new MatSort();

  @Input('hideFilter') hideFilter: boolean;
  @Input('hidePagination') hidePagination: boolean;
  @Input('displayedColumns')
  displayedColumns: string[];
  @Input('displayedColumnsOnDetail')
  displayedColumnsOnDetail: string[];
  @Input('dataSource')
  dataSource: MatTableDataSource<any>;
  @Input('configColumns')
  configColumns: IColumnConfigTableResponsive[];

  @Output() openShow: EventEmitter<any> = new EventEmitter();
  @Output() openShowMeeting: EventEmitter<any> = new EventEmitter();
  @Output() openNew: EventEmitter<any> = new EventEmitter();
  @Output() openEdit: EventEmitter<any> = new EventEmitter();
  @Output() openDelete: EventEmitter<any> = new EventEmitter();
  @Output() openQrcode: EventEmitter<any> = new EventEmitter();
  @Output() lock: EventEmitter<any> = new EventEmitter();
  @Output() unlock: EventEmitter<any> = new EventEmitter();
  @Output() active: EventEmitter<any> = new EventEmitter();
  @Output() inactive: EventEmitter<any> = new EventEmitter();
  @Output() lockPeople: EventEmitter<any> = new EventEmitter();
  @Output() unlockPeople: EventEmitter<any> = new EventEmitter();
  @Output() key: EventEmitter<any> = new EventEmitter();

  @Input()
  totalizers: {
    selectTotal: number;
    registrationTotal: number;
    activeTotal: number;
    deactiveTotal: number;
    lockTotal: number;
  } = {
      selectTotal: 0,
      registrationTotal: 0,
      activeTotal: 0,
      deactiveTotal: 0,
      lockTotal: 0,
    };

  private filterSubject = new Subject<string>();

  ngAfterViewInit() {
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
    this.selection.changed.subscribe((items) => {
      this.totalizers.selectTotal = this.selection.selected.length;
      this.onSelectionChange.emit(items);
    });
  }

  applyFilter(value: string) {
    this.filterSubject.next(value);
  }

  get typeIndexEnum() {
    return TypeIndexEnum;
  }

  get fieldTypeEnum() {
    return FieldTypeEnum;
  }

  public getUrl(value: string) {
    if (!value) {
      return 'assets/img/wazir/wazir-icon.svg';
    }
    return `${S3_URL_BASE}${value}`;
  }

  showRow(element: any, row: any) {
    element.idx = row;
    if (element.typeQuestion === 'REUNIAO') {
      this.openShowMeeting.emit(element);
    } else {
      this.openShow.emit(element);
    }
  }

  editRow(element: any, row: any) {
    element.idx = row;
    this.openEdit.emit(element);
  }

  deleteRow(element: any, row: any) {
    element.idx = row;
    this.openDelete.emit(element);
  }

  linkRow(element: any, row: any) {
    element.idx = row;
    this.openEdit.emit(element);
  }

  qrCodeRow(element: any, row: any) {
    element.idx = row;
    this.openQrcode.emit(element);
  }

  getValue(config: IColumnConfigTableResponsive, data: any) {
    return GlobalUtils.getValueByTypeColumnTableResponsive(config, data);
  }

  navigateToEvent(event: any): void {
    this.router.navigate(['form-event', event.id]);
  }

  navigateToMeeting(event: any): void {
    if (event && event.meeting && event.meeting.id) {
      this.router.navigate(['meeting-event', event.id, event.meeting.id]);
    } else {
      console.error('Dados da reunião ausentes ou inválidos para navegação:', event);
      this.toastService.showError('Não foi possível carregar os detalhes da reunião. Tente novamente mais tarde.');
    }
  }

  navigateToBriefing(event: any): void {
    this.router.navigate(['briefing-event', event.id]);
  }

  select(element: any, row: any) {
    element.idx = row;
    this.onSelect.emit(element);
  }

  public onCheckRow($event: MouseEvent, idx?: number) {
    if ($event) $event.stopPropagation();
    this.onSelect.emit($event);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.saleNumber + 1
      }`;
  }

  hasSelectConfig() {
    return this.displayedColumns.some((col) => col === 'select');
  }

  activeShowLockClass(element: any) {
    if (this.showLock) return element[this.activeProperty] ? 'active' : 'inactive';

    return 'active';
  }

}
